// @ts-nocheck
import React from "react";
import { cn } from "@/lib/utils";
import { tabDefs } from "./sellerDetail.constants";

export const SellerTabNav = ({ tab, onChange }) => (
  <div className="border-b border-slate-200 dark:border-slate-700 mb-6 overflow-x-auto">
    <nav className="flex gap-6 min-w-max">
      {tabDefs.map((t) => (
        <button
          key={t.key}
          data-testid={`tab-${t.key}`}
          onClick={() => onChange(t.key)}
          className={cn(
            "pb-3 text-sm font-medium border-b-2 -mb-px transition-colors whitespace-nowrap",
            tab === t.key
              ? "border-indigo-500 text-indigo-600 dark:text-indigo-400"
              : "border-transparent text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-300",
          )}
        >
          {t.label}
        </button>
      ))}
    </nav>
  </div>
);
